import { render } from "./ConfirmDialog.vue?vue&type=template&id=5d6d8462&scoped=true"
import script from "./ConfirmDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmDialog.vue?vue&type=script&lang=js"

import "./ConfirmDialog.vue?vue&type=style&index=0&id=5d6d8462&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Emers\\OneDrive\\Desktop\\Proyectos\\consultas-faber\\front-end-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d6d8462"]])

export default __exports__